// External
import { ActivatedRouteSnapshot, UrlTree, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Internal
import { ValuesService } from '../../values/values.service';
import { SubscriptionsService } from '../process/subscriptions/subscriptions.service';
import { NavigationService } from '../../navigation/navigation.service';

@Injectable({ providedIn: 'root' })

export class ATODevicesGuard {

    constructor(
        private readonly router: Router,
        private readonly valuesService: ValuesService,
        private readonly subscriptionsService: SubscriptionsService,
        private readonly navigationService: NavigationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
        const hasAtoConfiguration = this.subscriptionsService.hasATOConfiguration();
        const threatsDevicesPath = this.valuesService.centralPaths.ato.path.concat(this.valuesService.centralPaths.ato.threats.path, this.valuesService.centralPaths.ato.threats.devices.path);
        const activityPath = this.valuesService.centralPaths.ato.path.concat(this.valuesService.centralPaths.ato.activity.path);

        const urlProperties = this.navigationService.processUrl(route, state);
        const deviceCrc = urlProperties.urlParams[this.valuesService.queryParams.deviceCrc];

        if (hasAtoConfiguration) {
            if (deviceCrc) {
                this.router.navigate([threatsDevicesPath], { replaceUrl: true });
            } else {
                this.router.navigate([activityPath], { replaceUrl: true });
            }
        }

        return true;
    }
}